export default {
  title: 'CSE EMP',
  loginPageName: 'Login',
  logoutTip: 'Exit the system, do you want to continue?',
  submitText: 'submit',
  cancelText: 'cancel',
  search: 'Please input search content',
  menuTip: 'none menu list',
  common: {
    condition: 'condition',
    display: 'display',
    hide: 'hide',
  },
  tip: {
    select: 'Please select',
    input: 'Please input',
  },
  upload: {
    upload: 'upload',
    tip: 'Drag files here，/',
  },
  date: {
    start: 'Start date',
    end: 'End date',
    t: 'today',
    y: 'yesterday',
    n: 'nearly 7',
    a: 'whole',
  },
  form: {
    printBtn: 'print',
    mockBtn: 'mock',
    submitBtn: 'submit',
    emptyBtn: 'empty',
  },
  crud: {
    filter: {
      addBtn: 'add',
      clearBtn: 'clear',
      resetBtn: 'reset',
      cancelBtn: 'cancel',
      submitBtn: 'submit',
    },
    column: {
      name: 'name',
      hide: 'hide',
      fixed: 'fixed',
      filters: 'filters',
      sortable: 'sortable',
      index: 'index',
      width: 'width',
    },
    tipStartTitle: 'Currently selected',
    tipEndTitle: 'items',
    editTitle: 'edit',
    copyTitle: 'copy',
    addTitle: 'add',
    viewTitle: 'view',
    filterTitle: 'filter',
    showTitle: 'showTitle',
    menu: 'menu',
    addBtn: 'add',
    show: 'show',
    hide: 'hide',
    open: 'open',
    shrink: 'shrink',
    printBtn: 'print',
    excelBtn: 'excel',
    updateBtn: 'update',
    cancelBtn: 'cancel',
    searchBtn: 'search',
    emptyBtn: 'empty',
    menuBtn: 'menu',
    saveBtn: 'save',
    viewBtn: 'view',
    editBtn: 'edit',
    copyBtn: 'copy',
    delBtn: 'delete',
  },
  login: {
    loginHeader: 'Login',
    loginAcc: 'Account',
    loginAcctx: 'Please enter your Account Name',
    loginPass: 'Please enter your password',
    loginPasstx: 'Please enter your password',
    loginCode: 'Please enter the code',
    loginCodetx: 'Please enter the verification code',
    loginButton: 'Login',
    loginWait: 'Logging in, please wait',
    ces: 'CSE',
    emp: 'EMP',
    basicLoding: 'System loading',
    basictxLoading: 'CSE EMP System loading',
    title: 'Login ',
    account: 'Account',
    haveAccount: 'Don\'t have an account?',
    info: 'BladeX Development Platform',
    tenantId: 'Please input tenantId',
    username: 'Please input username',
    password: 'Please input a password',
    wechat: 'Wechat',
    qq: 'QQ',
    github: 'github',
    gitee: 'gitee',
    phone: 'Please input a phone',
    code: 'Please input a code',
    submit: 'Login',
    register: 'Register',
    userLogin: 'userLogin',
    phoneLogin: 'phoneLogin',
    thirdLogin: 'thirdLogin',
    ssoLogin: 'ssoLogin',
    msgText: 'send code',
    msgSuccess: 'reissued',
  },
  navbar: {
    info: 'info',
    logOut: 'logout',
    userinfo: 'userinfo',
    switchDept: 'switch dept',
    dashboard: 'dashboard',
    lock: 'lock',
    bug: 'none bug',
    bugs: 'bug',
    screenfullF: 'exit screenfull',
    screenfull: 'screenfull',
    language: 'language',
    notice: 'notice',
    theme: 'theme',
    color: 'color',
  },
  tagsView: {
    search: 'Search',
    menu: 'menu',
    clearCache: 'Clear Cache',
    closeOthers: 'Close Others',
    closeAll: 'Close All',
  },
  mBtn: {
    addSub: 'add a sub-item',
    dictConfig: 'Config',
    download: 'Download',
  },
  theader: {
    measuringPoint:'Measuring point',
    name: 'name',
    realTimeValue: 'Real-time value',
    unit: 'unit',
    updateTime: 'Update time',
    createTime: 'Create time',
    storage: 'Storage (minutes)',
    alerts: 'Alerts',
    operate: 'operate',
    project: 'project',
    area: 'area',
    detailAddress: 'Detailed address',
    protocol: 'protocol',
    correspondenceAddress: 'Correspondence address',
    dataTimeout: 'Data timeout (minutes)',
    serialNumber: 'Serial number',
    deviceId: 'Device ID',
    gatewayId: 'Gateway ID',
    gatewayName: 'Gateway Name',
    serialPortAddress: 'Serial port address',
    modelId: 'Model ID',
    creationTime: 'Creation time',
    updater: 'Updater',
    dataEncoding: 'Data Encoding',
    fourShakeAttributes: 'Four shake attributes',
    storage: 'Storage (minutes)',
    storageClass: 'Storage Class',
    alarmTime: 'Alarm time',
    recoveryTime: 'Recovery time',
    alarmLevel: 'Alarm level',
    alarmContent: 'Alarm content',
    reportName: 'Report Name',
    reportTime: 'Report time',
    equipmentFailureRate: 'Equipment failure rate',
    score: 'score',
    healthStatus: 'Health status',
    roleName: 'Role Name',
    tenants: 'Tenants',
    roleAliaes: 'Role Aliases',
    roleSorting: 'Role Sorting',
    institutionName: 'Institution Name',
    fullNameOfOrganization: 'Full name of organization',
    institutionType: 'Institution Type',
    sorting: 'Sorting',
    loginAccount: 'Login Account',
    userName: 'User Name',
    role: 'Role',
    department: 'Department',
    userPlatform: 'User Platform',
    potitionType: 'Position Type',
    positionNo: 'Position No.',
    potitionTitle: 'Position Title',
    potitionSorting: 'Position sorting',
    dictionaryNumber: 'Dictionary Number',
    dictionaryName: 'Dictionary Name',
    dictionarySorting: 'Dictionary sorting',
    archive: 'Archive',
    menuName: 'Menu Name',
    rutingAddress: 'Routing Address',
    menuIcon: 'Menu Icon',
    menuAliases: 'Menu Aliases',
    menuNo: 'Menu No.',
    menuSorting: 'Menu Sorting',
    tenantId: 'Tenant ID',
    tenantName: 'Tenant Name',
    contact: 'Contact',
    contactNumber: 'Contact Number',
    accountLimit: 'Account limit',
    expirationTime: 'Expiration time',
    bindDomainName: 'Bind domain name',
    projectArea: 'Project Area',
    reportAttributes: 'Report Attributes',
    description: 'Description',
    caculateFactor: 'Calculation Factor',
  }
};
